export const QUERY_KEY = ['estimations'];
export const DESKTOP_CARDS_COUNT = 3;
export const MOBILE_CARDS_COUNT = 2;
